import { createApp, h, ref } from 'vue'
import ToastComponent from './toast.vue'
import { ToastProps } from './interfaces.ts'

// 弹窗容器ID
const CONTAINER_ELEMENT_ID = 'toast_container'

// 默认参数
const initToastProps: ToastProps = {
  message: '',
  duration: 3000,
  position: 'center'
}

/**
 * 获取一个容器，如果不存在则新创建一个
 * @param id 容器id
 * @returns 容器Element
 */
const getContainerElement = (id: string): Element => {
  let $container = document.getElementById(id)
  if (!$container) {
    $container = document.createElement('div')
    $container.id = id
    document.body.appendChild($container)
  }
  return $container
}

let timer: number

/**
 * 创建一个toast
 * @param props 弹窗参数
 * @returns toast关闭方法
 */
function createToast(props: ToastProps): () => void {
  const $container: Element = getContainerElement(CONTAINER_ELEMENT_ID)
  clearTimeout(timer)
  const toastRef = ref<InstanceType<typeof ToastComponent>>()

  const app = createApp({
    setup() {
      return () => h(ToastComponent, {
        ...props,
        ref: toastRef,
        onHide() {
          app.unmount()
        }
      })
    }
  })
  app.mount($container)

  /**
   * 关闭toast
   */
  const close = () => {
    toastRef.value && toastRef.value.hide()
    clearTimeout(timer)
  }
  // 设置定时，如果duration为falsy包含0则不自动关闭
  if (props.duration) {
    timer = window.setTimeout(close, props.duration)
  }
  return close
}

/**
 * 获取一个MessageProps格式的参数
 * @param props 参数
 * @returns 转化后的参数
 */
const getProps = (props: ToastProps | string) => {
  if (typeof props !== 'string') {
    return props
  }
  return {
    message: props
  }
}

/**
 * toast弹窗
 * @param props 消息参数
 * @returns toast关闭方法
 */
const Toast = (props: ToastProps | string) => {
  return createToast(Object.assign({}, initToastProps, getProps(props)))
}

export default Toast
